/*
 * Copyright (C) Motorola Solutions, INC.
 * All Rights Reserved.
 */

import { ConfigurationMessage } from './abstract-configuration-message';

export class AGCSilenceMessage extends ConfigurationMessage {
  public static readonly RATE = 0.1;

  constructor(arrayBuffer?: ArrayBufferLike) {
    super(arrayBuffer);
    this.id = ConfigurationMessage.ConfigurationMessageIdentifier.AGC_SILENCE;
  }

  public withMultiplier(multiplier: number) {
    this.payload1 = multiplier;
    return this;
  }

    override payload1String(): string {
        return String(this.payload1 * 0.1);
    }
}
